var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6.875v-2.5a1.25 1.25 0 011.25-1.25h1.25V0h-2.5A3.75 3.75 0 002.5 3.75v3.125H0V10h2.5v10h3.75V10h2.5L10 6.875z",
    fill: "#80868b"
  })));
}

export default SvgFacebookGrey;